<template>
  <el-container>
    <div>
      <div class="hotel-info">
        <div style="height: 32px; line-height: 32px;">
          <span style="font-size: 28px; font-weight: 650; color: rgba(83, 102, 163, 1);">{{hotel.hotelname_en}}</span>
          <span style="font-size: 12px; margin-left: 40px; font-weight: 500;">
            <b style="margin-right: 3px;" v-for="val in hotel.hotelscore" :key="val">
              <img style="width:15px;height:15px;" src="/static/img/star.png">
            </b>
            <b style="margin-left: -3px;" v-if="hotel.star_decimal === 1">
              <img style="width:15px;height:15px;" src="/static/img/star-decimal.png">
            </b>
          </span>
        </div>
        <div style="font-size: 12px; margin-top: 5px;margin-bottom: 15px;">{{hotel.hoteladdress_en}}</div>
        <div style="border-bottom: 1px solid rgba(83, 102, 163, 1); border-width: 1px;"></div>
        <div class="order-info">
          <div class="oneline">
            <span class="left-info">Room type</span>
            <span class="right-info">{{orderData.roomName.en}}</span>
          </div>
          <div class="oneline">
            <span class="left-info">Night</span>
            <span class="right-info">{{orderData.nightCount}}</span>
          </div>
          <div class="oneline">
            <span class="left-info">Room</span>
            <span class="right-info">{{orderData.roomNum.en}}</span>
          </div>
          <div class="oneline">
            <span class="left-info">Guest</span>
            <span class="right-info">{{orderData.person.en}} {{orderData.child.en}}</span>
          </div>
          <div class="oneline">
            <span class="left-info">Bed type</span>
            <span class="right-info">{{orderData.bedType.en}}</span>
          </div>
          <div class="oneline">
            <span class="left-info">Check-in</span>
            <span class="right-info">{{orderData.checkin.en}}</span>
          </div>
          <div class="oneline">
            <span class="left-info">Check-out</span>
            <span class="right-info">{{orderData.checkout.en}}</span>
          </div>
          <div class="oneline">
            <span class="left-info">Breakfast :</span>
            <span class="right-info">{{orderData.breakfast.en}}</span>
          </div>
          <div class="oneline">
            <span class="left-info">Cancellation policy :</span>
            <span class="right-info">{{orderData.canceltext.en}}</span>
          </div>
        </div>
      </div>
    </div>
  </el-container>
</template>

<script>
export default {
  name: 'OrderTop',
  props: ['hotelOut', 'orderDataOut', 'language', 'nowPageData', 'paymentOn', 'TransactionFeeshow'],
  components: {},
  data () {
    return {
      hotel: {},
      orderData: {'roomName': {'zh': '', 'en': ''}, 'cancel': {'zh': '', 'en': ''}, 'night': {'zh': 1, 'en': 1}, 'roomNum': {'zh': 1, 'en': 1}, 'mandatoryFee': '', 'mandatoryTax': '', 'resortFee': '', 'payAtProperty': '', 'commission': '', 'hotelFeesEnText': '', 'cityFee': '', 'destinationFee': '', 'serviceFee': '', 'CleaningFee': '', 'administrativeFee': '', 'roomCount': '', 'nightCount': '', 'tax': ''},
      dateNumComplexStr: '',
      roomNumComplexStr: '',
      cancelData: 0,
      canceltextZh: '',
      canceltextEn: '',
      taxDia: false,
      cancelShowClose: false,
      taxShowClose: false,
      cancelDia: false,
      commissionDia: false,
      mandatoryFeeDetail: false,
      hotelShow: true,
      orderShow: true,
      paymentMethod: 'paypal'
    }
  },
  watch: {
    hotelOut: function (hotel) {
      console.log(hotel)
      this.hotel = hotel
      this.hotelShow = false
      this.orderShow = false
    },
    orderDataOut: function (orderData) {
      this.orderData = orderData
      this.cancelData = orderData.cancelData.en
      this.canceltextZh = orderData.canceltext.zh
      this.canceltextEn = orderData.canceltext.en
      // 判断夜是否大于1
      if (this.language === 'en' && orderData.night.en > 1) {
        this.dateNumComplexStr = 's'
      } else {
        this.dateNumComplexStr = ''
      }
      // 判断房间是否大于1
      if (this.language === 'en' && orderData.roomNum.en > 1) {
        this.roomNumComplexStr = 's'
      } else {
        this.roomNumComplexStr = ''
      }
      this.orderShow = false
    },
    paymentOn: function (val) {
      this.paymentMethod = val
    }
  },
  created () {},
  mounted () {},
  methods: {
    getLanguageHtml: function (data, type) {
      if (data === undefined) {
        return ''
      }
      var getLanguage = this.common.languageSet(this)
      if (['hotelname', 'hoteladdress'].includes(type)) {
        var typeLan = type + '_' + getLanguage
        return data[typeLan]
      } else if (['roomName', 'checkin', 'checkout', 'night', 'roomNum', 'person', 'child', 'bedType', 'breakfast', 'cancel', 'cancelData'].includes(type)) {
        if (getLanguage === 'zh') {
          return data.zh
        } else {
          return data.en
        }
      } else if (['userLastNameError', 'userNameError', 'emailError', 'telError', 'emailConfirmError'].includes(type)) {
        return this.$t(data)
      } else if (['buttonMeansYouAgree'].includes(type)) {
        return this.$t(type)
      }
    },
    delCoupon: function () {
      this.orderData.discount = ''
      var couponInfo = {'discountPrice': '', 'discountTotalPrice': '', 'discountPayPrice': '', 'userCouponId': '', 'couponId': '', discountTotalPriceCNY: '', discountTotalPriceUSD: ''}
      this.$emit('getCouponInfo', couponInfo)
    }
  },
  computed: {}
}
</script>

<style scoped>
/* 详情 */
/deep/ .el-collapse-item__header, .el-collapse, /deep/ .el-collapse-item__wrap{border: none; background-color: #f8f9fa;}
.list-content /deep/ .el-collapse-item__arrow{ display: none;}
.back-button{height: 20px;line-height: 20px;}
.back-img{width: 15px; height: 15px; margin: 2.5px; float: left;}
.hotel-info{ background-color: #FFF; padding:10px 1.5%;border-radius: 5px; margin-bottom: 15px;}
.hotel-name{height: 30px; line-height: 30px;}
.order-info{font-size: 12px; height: auto; line-height: 40px; clear: both; min-height: 210px;}
.oneline{clear: both; height: 40px; line-height: 40px}
.oneline span{display: inline-block;}
.left-info{ width: 12%;font-size: 14px; font-weight: 500; float: left;}
.right-info{width: 88%; float: left;font-size: 14px;}

/* 优惠券信息 */
.coupon-info{min-height: 22px;font-size:12px; padding: 0 5px; border-radius: 5px;background-color: #d2e6c8;box-sizing: border-box;color: #2f7000;text-align: left;line-height: normal;margin: 0px 4.5%;font-size: 12px;line-height: 22px; display: flex;align-items: center;}
.coupon-text{color: #2f7000;text-align: left;font-size: 12px;padding: 0 2.5% 0 4.5%;}
.coupon-img{width:20px; height:20px;line-height: 22px;vertical-align: middle;}
.coupon-info img{vertical-align: middle;}
/* 住房须知 */
.hotelFeesText /deep/ p{margin-block-start: 5px;margin-block-end: 5px;}
.hotelFeesText /deep/ ul{margin-left:20px;margin-bottom: 10px;}

</style>



// WEBPACK FOOTER //
// src/components/order/module/OrderTop.vue